import { Button, ModalBody, ModalFooter, ModalHeader, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SubmitFormBtn } from '../Buttons/SubmitFormBtn';
import { BaseModal } from './BaseModal';

interface IUserConfirmResetScore {
  isOpen: boolean;
  onClose: VoidFunction;
  onConfirm: VoidFunction;
}

export const UserConfirmResetScore = (props: IUserConfirmResetScore) => {
  const { t } = useTranslation();
  const { isOpen, onClose, onConfirm } = props;

  return (
    <BaseModal isOpen={isOpen} onClose={onClose}>
      <>
        <ModalHeader>{t('modal.reset.score.caption')}</ModalHeader>

        <ModalBody>
          <Text lineHeight='150%'>{t('modal.deleting.score.text.1')}</Text>
        </ModalBody>

        <ModalFooter>
          <VStack spacing={4}>
            <SubmitFormBtn size='lg' minH={14} py={2} onClick={onConfirm}>
              {t('confirm.reset')}
            </SubmitFormBtn>
            <Button variant='linkUnderlinePrimary' size='sm' onClick={onClose}>
              {t('cancel')}
            </Button>
          </VStack>
        </ModalFooter>
      </>
    </BaseModal>
  );
};
